import React from "react";
import {useFormikContext} from "formik";
import PaymentFileUploader from "./PaymentFileUploader";
import {usePolicyContext} from "./PolicyContext";
import PaymentFileViewer from "./PaymentFileViewer";
import { Grid } from "@material-ui/core";
import { cssPaths } from "../../../constants";
import {CircularLoading as Loader} from "../../Common";
import {sleep} from "../../../utils/commonUtils";
import {TO_BE_VOIDED} from "../../../constants";

function PaymentDocument(props: any) {
    const {fieldName} = props;
    const fileType = "image/jpg, image/jpeg, image/png, application/pdf";
    const [loader, setLoader] = React.useState(false);
    const {policy} = usePolicyContext();
    const {values, setFieldValue}: any = useFormikContext()
    const policyNumber = policy && policy.policyNumber;
    const setPaymentDocumentPath = async (filePath: string) => {
        setLoader(true);
        await sleep(2500);
        filePath = filePath.replace(new RegExp('ToBeVoided', 'i'), ''); // hack to remove ToBeVoided after upload
        setFieldValue(fieldName, filePath);
        setLoader(false);
    };
    return (<>
        {values[fieldName] === "" && <>
            <PaymentFileUploader
                    isSecuredSignedUrl={true}
                    fileType={fileType}
                    dirName={policyNumber}
                    fileName={`ManualPaymentDocument`}
                    setFileName={setPaymentDocumentPath}
                    title="Upload payment document"
            />
        </>
        }
        {values[fieldName] &&
                <Grid item xs={12} md={3}>
                    <PaymentFileViewer
                            fileName={values[fieldName]}
                            policyNumber={policyNumber}
                            title={"Payment Document"}
                            readOnly={false}
                            deleteFile={() => {
                                setPaymentDocumentPath('');
                            }}
                    />
                </Grid>
        }
        {
                loader && <Loader />
        }
    </>);

}

export default PaymentDocument;